import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if @tagName}}
  {{!
    Older outlets have a wrapper tagName. RFC0389 proposes an interface for dynamic tag names, which we may want to use in future.
    But for now, this classic component wrapper takes care of the tagName.
  }}
  <this.wrapperComponent @tagName={{@tagName}}>
    {{#each (this.getConnectors) as |c|}}
      {{#if c.componentClass}}
        <c.componentClass @outletArgs={{this.outletArgsWithDeprecations}} />
      {{else if @defaultGlimmer}}
        <c.templateOnly @outletArgs={{this.outletArgsWithDeprecations}} />
      {{else}}
        <PluginConnector
          @connector={{c}}
          @args={{this.outletArgs}}
          @deprecatedArgs={{@deprecatedArgs}}
          @outletArgs={{this.outletArgsWithDeprecations}}
          @tagName={{or @connectorTagName ""}}
          @layout={{c.template}}
          class={{c.classicClassNames}}
        />
      {{/if}}
    {{/each}}
  </this.wrapperComponent>
{{else if (this.connectorsExist hasBlock=(has-block))}}
  {{! The modern path: no wrapper element = no classic component }}

  {{#if (has-block)}}
    <PluginOutlet
      @name={{concat @name "__before"}}
      @outletArgs={{this.outletArgsWithDeprecations}}
    />
  {{/if}}

  {{#each (this.getConnectors hasBlock=(has-block)) as |c|}}
    {{#if c.componentClass}}
      <c.componentClass
        @outletArgs={{this.outletArgsWithDeprecations}}
      >{{yield}}</c.componentClass>
    {{else if @defaultGlimmer}}
      <c.templateOnly
        @outletArgs={{this.outletArgsWithDeprecations}}
      >{{yield}}</c.templateOnly>
    {{else}}
      <PluginConnector
        @connector={{c}}
        @args={{this.outletArgs}}
        @deprecatedArgs={{@deprecatedArgs}}
        @outletArgs={{this.outletArgsWithDeprecations}}
        @tagName={{or @connectorTagName ""}}
        @layout={{c.template}}
        class={{c.classicClassNames}}
      >{{yield}}</PluginConnector>
    {{/if}}
  {{else}}
    {{yield}}
  {{/each}}

  {{#if (has-block)}}
    <PluginOutlet
      @name={{concat @name "__after"}}
      @outletArgs={{this.outletArgsWithDeprecations}}
    />
  {{/if}}
{{else}}
  {{yield}}
{{/if}}
*/
{
  "id": "2aKzlaXm",
  "block": "[[[41,[30,1],[[[1,\"  \"],[8,[30,0,[\"wrapperComponent\"]],null,[[\"@tagName\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[28,[30,0,[\"getConnectors\"]],null,null]],null]],null],null,[[[41,[30,2,[\"componentClass\"]],[[[1,\"        \"],[8,[30,2,[\"componentClass\"]],null,[[\"@outletArgs\"],[[30,0,[\"outletArgsWithDeprecations\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"        \"],[8,[30,2,[\"templateOnly\"]],null,[[\"@outletArgs\"],[[30,0,[\"outletArgsWithDeprecations\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,3],[[16,0,[30,2,[\"classicClassNames\"]]]],[[\"@connector\",\"@args\",\"@deprecatedArgs\",\"@outletArgs\",\"@tagName\",\"@layout\"],[[30,2],[30,0,[\"outletArgs\"]],[30,4],[30,0,[\"outletArgsWithDeprecations\"]],[28,[37,4],[[30,5],\"\"],null],[30,2,[\"template\"]]]],null],[1,\"\\n      \"]],[]]]],[]]]],[2]],null],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[28,[30,0,[\"connectorsExist\"]],null,[[\"hasBlock\"],[[48,[30,8]]]]],[[[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"    \"],[8,[39,6],null,[[\"@name\",\"@outletArgs\"],[[28,[37,7],[[30,6],\"__before\"],null],[30,0,[\"outletArgsWithDeprecations\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[28,[30,0,[\"getConnectors\"]],null,[[\"hasBlock\"],[[48,[30,8]]]]]],null]],null],null,[[[41,[30,7,[\"componentClass\"]],[[[1,\"      \"],[8,[30,7,[\"componentClass\"]],null,[[\"@outletArgs\"],[[30,0,[\"outletArgsWithDeprecations\"]]]],[[\"default\"],[[[[18,8,null]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"      \"],[8,[30,7,[\"templateOnly\"]],null,[[\"@outletArgs\"],[[30,0,[\"outletArgsWithDeprecations\"]]]],[[\"default\"],[[[[18,8,null]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,3],[[16,0,[30,7,[\"classicClassNames\"]]]],[[\"@connector\",\"@args\",\"@deprecatedArgs\",\"@outletArgs\",\"@tagName\",\"@layout\"],[[30,7],[30,0,[\"outletArgs\"]],[30,4],[30,0,[\"outletArgsWithDeprecations\"]],[28,[37,4],[[30,5],\"\"],null],[30,7,[\"template\"]]]],[[\"default\"],[[[[18,8,null]],[]]]]],[1,\"\\n    \"]],[]]]],[]]]],[7]],[[[1,\"    \"],[18,8,null],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"    \"],[8,[39,6],null,[[\"@name\",\"@outletArgs\"],[[28,[37,7],[[30,6],\"__after\"],null],[30,0,[\"outletArgsWithDeprecations\"]]]],null],[1,\"\\n\"]],[]],null]],[]],[[[1,\"  \"],[18,8,null],[1,\"\\n\"]],[]]]],[]]]],[\"@tagName\",\"c\",\"@defaultGlimmer\",\"@deprecatedArgs\",\"@connectorTagName\",\"@name\",\"c\",\"&default\"],false,[\"if\",\"each\",\"-track-array\",\"plugin-connector\",\"or\",\"has-block\",\"plugin-outlet\",\"concat\",\"yield\"]]",
  "moduleName": "discourse/components/plugin-outlet.hbs",
  "isStrictMode": false
});